export default {
  methods: {
    successToast(text, append = false) {
      const content = this.$createElement('div', { class: ['d-flex', 'align-items-center'] }, [
        this.$createElement('div', {}, [<font-awesome-icon icon="fa-solid fa-check" class="" />]),
        this.$createElement('div', { class: 'ml-2' }, text)
      ])

      this.$bvToast.toast([content], {
        autoHideDelay: 5000,
        appendToast: append,
        toaster: 'b-toaster-bottom-right',
        toastClass: 'success-toast-body',
        noCloseButton: true,
        bodyClass: 'success-toast'
      })
    }
  }
}
